import React from 'react';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';
import ReactDOM from 'react-dom';
import {BrowserRouter} from "react-router-dom";
import App from './App';
import * as serviceWorker from './serviceWorker';
import './fonts.css';
import './bootstrap-custom.css';
import './index.css';
import './i18n';
import {BreakpointProvider} from './util/handleBreakpoints';
import {LocalContextProvider} from './context/LocalContext';
import {SessionContextProvider} from './context/SessionContext';
import ReactGA from 'react-ga';
// import * as Sentry from "@sentry/react";

// Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN });

import * as Sentry from "@sentry/react";
if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN,
    });
}

const mediaQueries = {
    xs: '(max-width: 575.98px)',
    sm: '(max-width: 767.98px)',
    md: '(max-width: 991.98px)',
    lg: '(max-width: 1199.98px)',
    or: '(orientation: portrait)'
}

if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) {
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
    ReactGA.pageview(window.location.pathname + window.location.search);
}

ReactDOM.render(
    <LocalContextProvider>
        <SessionContextProvider>
            <BrowserRouter>
                <BreakpointProvider queries={mediaQueries}>
                    <GoogleReCaptchaProvider
                        reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        useRecaptchaNet={true}
                    >
                        <App />
                    </GoogleReCaptchaProvider>
                </BreakpointProvider>
            </BrowserRouter>
        </SessionContextProvider>
    </LocalContextProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
